import React, { Component } from 'react';
import { Modal, Button, Table, Badge } from 'react-bootstrap';
import moment from 'moment';

export default class CorrectionHistoryPopup extends Component {
    renderCorrectionBadge = (reason) => {
        const badgeVariants = {
            'Data Entry Error': 'danger',
            'Lab Result Update': 'warning',
            'Patient Information Update': 'info',
            'Insurance Information Update': 'primary',
            'Provider Information Update': 'secondary',
            'Diagnosis Code Update': 'success',
            'Sample Information Update': 'warning',
            Other: 'dark'
        };

        return <Badge variant={badgeVariants[reason] || 'secondary'}>{reason}</Badge>;
    };

    render() {
        const { show, onClose, correctionHistory = [] } = this.props;

        return (
            <Modal show={show} onHide={onClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Correction History</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {correctionHistory.length === 0 ? (
                        <div className="text-center py-4 text-muted">
                            <i className="fas fa-history fa-3x mb-3"></i>
                            <p>No corrections have been made to this order.</p>
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Correction Date</th>
                                        <th>Reason</th>
                                        <th>Notes</th>
                                        <th>Corrected By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {correctionHistory.map((correction, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{moment(correction.correction_date).format('MM/DD/YYYY')}</td>
                                            <td>{this.renderCorrectionBadge(correction.reason)}</td>
                                            <td>{correction.notes || <span className="text-muted">No notes</span>}</td>
                                            <td>{correction.corrected_by}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
